import ShieldRoundedIcon from "@mui/icons-material/ShieldRounded";
import WarningRoundedIcon from "@mui/icons-material/WarningRounded";
import LocalFireDepartmentRoundedIcon from "@mui/icons-material/LocalFireDepartmentRounded";
import MedicalServicesRoundedIcon from "@mui/icons-material/MedicalServicesRounded";
import InfoRoundedIcon from "@mui/icons-material/InfoRounded";

export const CATEGORY_META = {
  pdv: {
    label: "Dödligt våld (PDV)",
    short: "PDV",
    color: "#8a1125",
    dark: "#6b0d1d",
    tint: "rgba(138,17,37,0.08)",
    border: "rgba(138,17,37,0.32)",
    halo: "rgba(138,17,37,0.18)",
    icon: ShieldRoundedIcon,
  },
  bombhot: {
    label: "Bombhot",
    short: "BOMB",
    color: "#b25300",
    dark: "#8a3f00",
    tint: "rgba(178,83,0,0.09)",
    border: "rgba(178,83,0,0.32)",
    halo: "rgba(178,83,0,0.18)",
    icon: WarningRoundedIcon,
  },
  brand: {
    label: "Brandlarm",
    short: "BRAND",
    color: "#c43d2f",
    dark: "#9a2c20",
    tint: "rgba(196,61,47,0.08)",
    border: "rgba(196,61,47,0.32)",
    halo: "rgba(196,61,47,0.18)",
    icon: LocalFireDepartmentRoundedIcon,
  },
  olycka: {
    label: "Olycka",
    short: "OLYCKA",
    color: "#5f3a8f",
    dark: "#42276a",
    tint: "rgba(95,58,143,0.08)",
    border: "rgba(95,58,143,0.32)",
    halo: "rgba(95,58,143,0.18)",
    icon: MedicalServicesRoundedIcon,
  },
  ovrigt: {
    label: "Övrigt",
    short: "ÖVRIGT",
    color: "#10324a",
    dark: "#0a2235",
    tint: "rgba(16,50,74,0.08)",
    border: "rgba(16,50,74,0.32)",
    halo: "rgba(16,50,74,0.18)",
    icon: InfoRoundedIcon,
  },
};

export const metaForKey = (key) => CATEGORY_META[key] || CATEGORY_META.ovrigt;

export const styleForEmergencyType = (type) => {
  const key = (type || "").toLowerCase();
  if (CATEGORY_META[key]) return CATEGORY_META[key];
  if (key.includes("pdv") || key.includes("våld") || key.includes("vald"))
    return CATEGORY_META.pdv;
  if (key.includes("bomb")) return CATEGORY_META.bombhot;
  if (key.includes("brand") || key.includes("fire")) return CATEGORY_META.brand;
  if (key.includes("olycka") || key.includes("medic"))
    return CATEGORY_META.olycka;
  return CATEGORY_META.ovrigt;
};
